import { FC } from "react";
import Modal from "components/Modal";
import { FormInput, FormNotice, formStyles as styles } from "shared/ui";
import { useChangePassword } from "../model/useChangePassword";
import { PASSWORD_INPUTS } from "./passwordInputs";

interface Props {
  onClose: () => void;
}

export const ChangePasswordModal: FC<Props> = ({ onClose }) => {
  const form = useChangePassword();

  return (
    <Modal isOpen onClose={onClose} title="Change Password">
      {form.isChanged ? (
        <FormNotice onClose={onClose}>
          Your password has been changed.
        </FormNotice>
      ) : (
        <form
          className={styles.form}
          noValidate
          onSubmit={(event) => {
            event.preventDefault();
            form.submit();
          }}
        >
          {PASSWORD_INPUTS.map(({ field, placeholder, autoComplete }) => (
            <FormInput
              key={field}
              type="password"
              placeholder={placeholder}
              autoComplete={autoComplete}
              value={form.values[field]}
              error={form.errors[field]}
              onValueChange={(value) => form.setValue(field, value)}
              disabled={form.isSubmitting}
              autoFocus={field === "current"}
            />
          ))}
          {form.serverError && (
            <p className={styles.error}>{form.serverError}</p>
          )}
          <button
            type="submit"
            className={styles.submitButton}
            disabled={form.isSubmitting}
          >
            {form.isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>
      )}
    </Modal>
  );
};
